import type { InputProps } from '@mui/material'
import type { ChangeEventHandler, DetailedHTMLProps, FC, InputHTMLAttributes, Ref } from 'react'

type Props = {
  id: InputHTMLAttributes<InputProps>['id']
  name: string
  inputRef: Ref<HTMLInputElement>
  onChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>
} & DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>

/** name は必須。入力要素には必ず name を付ける (.claude/rules/web.md) */
export const FileInput: FC<Props> = ({ id, name, inputRef, onChange, ...rest }) => {
  return <input id={id} name={name} ref={inputRef} type="file" onChange={onChange} {...rest} />
}
